export const environment = {
  production: true,
  apiURL: 'https://admin.imitwala.com/api/',
  //apiURL: 'http://www.itwala/api/',
};
